import dataService from 'services/dataService';
import { API_PATIENTS_APPOINTMENTS } from 'services/dataService/resources';
import { showResult } from 'infrastructure/hooks/utils';

interface DataProps {
  patientGuid: string;
  rogerModule?: string;
}

export const sendAppointmentRequestFn = async (postData: DataProps) => {
  const { error, data } = await dataService.createOne(
    API_PATIENTS_APPOINTMENTS,
    postData,
  );

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return data;
};
